import { render, staticRenderFns } from "./AppStoresPage.html?vue&type=template&id=204e6fa4&"
import script from "./AppStoresPage.js?vue&type=script&lang=js&"
export * from "./AppStoresPage.js?vue&type=script&lang=js&"
import style0 from "./AppStoresPage.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports